import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaBars } from "react-icons/fa6";
import { CiCircleRemove } from "react-icons/ci";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constant";
import axios from "axios";
import { Badge } from "antd";
import { useWishlistContext } from "../../Context/WishlistContext";
import { useCartContext } from "../../Context/CartContext";
import { Search, Heart, ShoppingBag, User, Info } from "lucide-react";
import logo from "../.././images/pbk.png";
import logoflip from "../.././images/pbk2.png";
import CustomHeader from "../CustomHeader";

const Header = ({ setNavigatedCategory }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [resMenu, setResMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { wishlistCount, fetchWishlistCount } = useWishlistContext();
  const { cartCount, fetchCartCount } = useCartContext();
  const [categories, setCategories] = useState([]);

  const logo2 = logoflip;
  const [currentLogo, setCurrentLogo] = useState(logo2); // Initial logo
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentLogo((prevLogo) => (prevLogo === logo ? logo2 : logo));
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    fetchCartCount();
    fetchWishlistCount();
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [menuOpen]);

  const handleSearchProduct = async () => {
    navigate(`/shop?search=${searchTerm}`);
  };

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const userId = localStorage.getItem("userId");
  const handleLogout = async () => {
    localStorage.removeItem("userId");
    await fetchCartCount();
    toast.success("Logout successfully");

    navigate("/");
  };

  const handleResMenuToggle = () => {
    setResMenu(!resMenu);
  };

  useEffect(() => {
    fetch(`${BASE_URL}/api/headerMenu`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  return (
    <>
      <nav>
        <input type="checkbox" name="check" id="check" checked={menuOpen} />
        <div className="bars-container">
          <label
            htmlFor="check"
            className="checkbtn"
            onClick={handleMenuToggle}
          >
            {menuOpen ? (
              <CiCircleRemove />
            ) : (
              <FaBars className="fabars" size={30} />
            )}
          </label>
        </div>
        <div class="logo-container">
          <Link to={"/"} className="logo">
            <img
              className="logo"
              src={currentLogo}
              alt="Logo"
              style={{ height: "70px", width: "70px" }}
            />
          </Link>
        </div>
        <ul className={menuOpen ? "show" : "normal"}>
          {categories.map((cat) => (
            <li key={cat.id}>
              {" "}
              <Link
                onClick={() => setNavigatedCategory("men")}
                to={`/shop?category=${cat.name}`}
                style={{ textTransform: "uppercase" }}
                className="link"
              >
                {cat.name}
              </Link>
            </li>
          ))}

          {/*only for responsive mode */}

          <li className="responsive">
            <Badge id="res-info-badge">
              <Link to="/about" className="link">
                About Us
              </Link>
            </Badge>
          </li>
          <li className="responsive">
            <Badge id="res-heart-badge" count={wishlistCount} showZero>
              <Link to="/wishlist" className="link">
                Wishlist
              </Link>
            </Badge>
          </li>
          <li className="responsive">
            <Badge id="res-cart-badge" count={cartCount} showZero>
              <Link to="/cart" className="link">
                Cart
              </Link>
            </Badge>
          </li>

          {userId ? (
            <li className="responsive">
              <Link
                to=""
                className="link"
                id="res-profile"
                onClick={handleResMenuToggle}
              >
                User Dashboard <IoIosArrowDown />
                {resMenu && (
                  <ul className="res-menu">
                    <li>
                      <Link to={"/profile"}>Account</Link>
                    </li>
                    <li>
                      <Link to={"/order-history"}>Orders</Link>
                    </li>
                    <li>
                      <Link to={"/wishlist"}>Wishlist</Link>
                    </li>
                    <li>
                      <Link to={"/"} onClick={handleLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                )}
              </Link>
            </li>
          ) : (
            <li className="responsive">
              <Link to="/login" className="link">
                Sign up/ Login
              </Link>
            </li>
          )}
        </ul>
        <div className="d-flex align-items-center ">
          <div className="nav-search-bar search-container">
            <form
              className="nav-search-bar search-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <button
                type="button"
                className="search-button"
                onClick={handleSearchProduct}
              >
                <Search size={25} color="black" />
              </button>
              <input
                type="text"
                id="search-box"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearchProduct();
                  }
                }}
              />
            </form>
          </div>
          <div className="nav-icons">
            <Badge id="info-badge">
              <Link to="/about" className="info-icon">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1C19.6277 1 25 6.3723 25 13C25 19.6277 19.6277 25 13 25C6.37231 25 1 19.6277 1 13C1 6.3723 6.37231 1 13 1ZM13 3.3999C7.69815 3.3999 3.39969 7.69805 3.39969 13.0002C3.39969 18.3024 7.69784 22.6005 13 22.6005C18.3022 22.6005 22.6003 18.3024 22.6003 13.0002C22.6003 7.69805 18.3022 3.3999 13 3.3999ZM13 10.6C13.6154 10.6 14.1226 10.8702 14.1919 11.2183L14.2 11.3001V18.3001C14.2 18.6869 13.6628 19.0002 13 19.0002C12.3847 19.0002 11.8774 18.73 11.8081 18.3819L11.8001 18.3001V11.3001C11.8001 10.9134 12.3372 10.6 13 10.6ZM13 6.99995C13.6628 6.99995 14.1999 7.53733 14.1999 8.2001C14.1999 8.86287 13.6628 9.40005 13 9.40005C12.3372 9.40005 11.8001 8.86287 11.8001 8.2001C11.8001 7.53733 12.3372 6.99995 13 6.99995Z"
                    fill="#221F20"
                    fill-opacity="0.9"
                    stroke="white"
                    stroke-width="0.4"
                  ></path>
                </svg>
              </Link>
            </Badge>
            <Badge id="heart-badge" count={wishlistCount} showZero>
              <Link to="/wishlist" className="heart-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  overflow="unset"
                  className="icon"
                >
                  <path
                    d="M12 4.95276C9.55556 -0.930046 1 -0.303473 1 7.21544C1 14.7343 12 21 12 21C12 21 23 14.7343 23 7.21544C23 -0.303473 14.4444 -0.930046 12 4.95276Z"
                    stroke="#221F20"
                    stroke-opacity="0.9"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </Link>
            </Badge>
            <Badge id="cart-badge" count={cartCount} showZero>
              <Link to="/cart" className="cart-icon">
                <svg
                  width="31"
                  height="25"
                  viewBox="0 0 15 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.2955 6.09681H16.3956V5.79153C16.3956 2.59295 13.8423 0 10.6951 0C7.548 0 4.9947 2.59313 4.9947 5.79153V6.09681H1.09477C0.598642 6.09681 0.195312 6.5067 0.195312 7.01263V21.6471C0.195312 23.4994 1.67194 25 3.49448 25H17.8961C19.7187 25 21.1953 23.4993 21.1953 21.6471V7.01263C21.1953 6.50671 20.792 6.09681 20.2959 6.09681H20.2955ZM6.79504 5.79153C6.79504 3.60312 8.54167 1.82808 10.695 1.82808C12.8483 1.82808 14.5949 3.60317 14.5949 5.79153V6.09681H6.79486L6.79504 5.79153ZM19.3961 21.6452V21.647C19.3961 22.0517 19.2374 22.4393 18.9556 22.724C18.6755 23.0104 18.2924 23.1716 17.8958 23.1716H3.49418C2.66558 23.1716 1.99392 22.489 1.99392 21.6469V7.92655H4.9944V10.6706C4.9944 11.1748 5.39772 11.5847 5.89554 11.5847C6.39166 11.5847 6.79499 11.1748 6.79499 10.6706V7.92655H14.595V10.6706C14.595 11.1748 14.9984 11.5847 15.4945 11.5847C15.9923 11.5847 16.3956 11.1748 16.3956 10.6706V7.92655H19.3961L19.3961 21.6452Z"
                    fill="#221F20"
                    fill-opacity="0.9"
                  ></path>
                </svg>
              </Link>
            </Badge>
            {userId ? (
              <React.Fragment>
                <Link to="" className="user-icon">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 19 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 23C18 18.2749 14.1944 14.4444 9.5 14.4444C4.80558 14.4444 1 18.2749 1 23M9.5 10.7778C6.81747 10.7778 4.64286 8.58895 4.64286 5.88889C4.64286 3.18883 6.81747 1 9.5 1C12.1825 1 14.3571 3.18883 14.3571 5.88889C14.3571 8.58895 12.1825 10.7778 9.5 10.7778Z"
                      stroke="#221F20"
                      stroke-opacity="0.9"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </Link>
                <div className="user-menu">
                  <ul>
                    <li>
                      <Link to="/profile" id="user-link">
                        Account
                      </Link>
                    </li>
                    <li>
                      <Link to="/order-history" id="user-link">
                        Orders
                      </Link>
                    </li>
                    <li>
                      <Link to="/wishlist" id="user-link">
                        Wishlist
                      </Link>
                    </li>
                    <li>
                      <Link to="/" id="user-link" onClick={handleLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            ) : (
              <Badge id="user-badge">
                <Link to="/login" className="user-profile-btn">
                  <User size={30} />
                </Link>
              </Badge>
            )}
          </div>
        </div>
      </nav>
      {isMobile ? (
        <CustomHeader setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
